var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHeart = function SvgHeart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 -1 21 19"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 1.2,
    d: "M14.74.75c1.21 0 2.21.4 3.04 1.19l.17.16c.86.91 1.3 2.04 1.3 3.43 0 .62-.09 1.23-.27 1.84l-.09.26a9 9 0 0 1-1.07 2.03l-.23.33c-.64.89-1.51 1.93-2.64 3.1a123 123 0 0 1-4.3 4.27l-.48.45a.25.25 0 0 1-.3.03l-.04-.03-.48-.45c-1.3-1.25-2.43-2.36-3.4-3.33l-.9-.93a32 32 0 0 1-2.4-2.77l-.24-.34q-.84-1.185-1.2-2.1l-.1-.26a6.4 6.4 0 0 1-.36-2.1c0-1.3.39-2.38 1.15-3.25l.15-.18A4.22 4.22 0 0 1 5.26.75c.7 0 1.35.15 1.98.45l.27.13c.7.4 1.33.96 1.88 1.73l.61.85.61-.85a5.8 5.8 0 0 1 1.62-1.57l.26-.16a4.6 4.6 0 0 1 2.25-.58Z"
  })));
};
export default SvgHeart;